export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8602.88581426.jpg";